<template>
        <div class="bt-atıs-dep-main">

            <div class="image-pilot">
                <img :src="getSvgStreamUrl" @error="errorsvg(0)" @load="errorsvg(1)" onerror="this.style.display='none'" alt="svg">
            </div>
            <div>
                <p v-if="!Svgshow"> Svg file couldn't get...</p>
            </div>

            <div class="field">
                <p class="heading is-size-6 has-text-centered">ATIS DEP Pilot Input</p>
            </div>

            <div class="content" :class = "{hide : !Jpegshow}">
                <img :src="getJpegStreamUrl" @error="errorjpeg(0)" @load="errorjpeg(1)" onerror="this.style.display='none'" alt="" width="100%" height="100%">
            </div>

            <div>
                <p v-if="!Jpegshow"> Jpg file couldn't get...</p>
            </div>

            <div class="field">
                <p class="heading is-size-6 has-text-centered">ATIS DEP Pilot Photo</p>
            </div>

            <div class="photo-pilot">
                <h2 style="font-size: 1.5rem; margin-left: 40px; margin-bottom: 20px">Notes</h2>
                <textarea name="clearence-text" id="" cols="20" rows="14" class="textarea" v-if="InputsObject.BTO.atisDepText" v-model="InputsObject.BTO.atisDepText" readonly></textarea>
            </div>

        </div>
</template>

<script>

    import 'filepond/dist/filepond.min.css';
    import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
    import {createUrl} from "../../../../http";
    import {mapState} from "vuex";

    export default {
        name: "AtısDep",
        props: ["id", "flight", "additionalCrew"],
        data(){
          return {
              getSvgStreamUrl : "",
              getJpegStreamUrl : "",
              activeJpegUrl : createUrl('/EffIpadPreview/GetInputJpeg/'),
              activeSvgUrl : createUrl('/EffIpadPreview/GetInputSVG/'),
              Jpegshow : true,
              Svgshow : true,
          }
        },

        created()
        {
            this.getSvgStreamUrl = this.activeSvgUrl + this.id + "/" + this.flight.std + "/"+this.ActiveDevice_UID+"/" + "BTO_AtisDep.svg"+"/"+this.flight.flightArchiveStat;

            this.getJpegStreamUrl = this.activeJpegUrl + this.id + "/" + this.flight.std + "/" +this.ActiveDevice_UID+"/"+ "BTO_AtisDep.jpg"+"/"+this.flight.flightArchiveStat;
        },

        methods: {

            errorsvg(stat)
            {
                if (stat ==0)
                {
                    this.Svgshow = false;
                }
                else if(stat ==1)
                {
                    this.Svgshow = true;
                }
            },

            errorjpeg(stat)
            {
                if (stat ==0)
                {
                    this.Jpegshow = false;
                }
                else if(stat ==1)
                {
                    this.Jpegshow = true;
                }
            }

        },

        computed: {

            ...mapState("ipadmain",[ "ActiveDevice_UID","selectedFlightItems","EFF_Json_Data","WR_Json_Data","AttachmentsJson","OCCSelfVersions_VS_IPADLastKnownVersions","LastInputsJson","InputsObject"]),

        },

        components: {

        }

    }
</script>

<style scoped>

    .image-pilot {

    }

    .photo-pilot {
        height: 400px;
        position: center;

    }

    .filepond--drop-label {
        background-color: black;
        color: #FFFFFF;
    }

    img{
        width: 100%;
    }
</style>
